export default __webpack_public_path__ + "static/media/agenda.7d3a2e72.png";